import {Component, Input, ViewChild} from '@angular/core';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgWidgetComponent} from 'exc-controls-v2';

@Component({
  selector: 'app-sv-user-profile',
  templateUrl: './sv-user-profile.component.html',
  styles: []
})
export class SvUserProfileComponent {
  @ViewChild('widget', {read: ExgWidgetComponent}) widget!: ExgWidgetComponent;

  @Input()
  set data(value: any) {
    // User aus liste
    if (value) {
      this._data = value;
    }
  }
  get data(): any {
    Object.assign(this._data, {settingType: this.settingType});
    return this._data;
  }
  private _data: any = {};

  get settingType(): number | undefined {
    return this._settingType;
  }
  private _settingType: number | undefined;

  currentUser = '';
  currentWidget = 'SvOeDasboardComponent';
  public sidemenu = [
    {type: 0, icon: '', caption: 'Scoring', component: null, disabled: false},
    {type: 1, icon: 'far fa-tachometer-alt-fast', caption: 'Dashboard', component: 'SvOeDasboardComponent', disabled: false},
    {type: 1, icon: 'far fa-star', caption: 'Bewertungen', component: 'SvUserScoringComponent', disabled: false},
    {type: 0, icon: '', caption: 'Disposition', component: null, disabled: false},
    {
      type: 1,
      icon: 'far fa-route',
      caption: 'Kapazitäten',
      component: 'SvUserDispositionsettingsComponent',
      disabled: false,
      settingType: 0
    },
    {
      type: 1,
      icon: 'far fa-suitcase',
      caption: 'Abwesenheiten',
      component: 'SvUserDispositionsettingsComponent',
      disabled: false,
      settingType: 1
    },
    {
      type: 1,
      icon: 'far fa-map',
      caption: 'Black- & Whitelist',
      component: 'SvUserDispositionsettingsComponent',
      disabled: false,
      settingType: 2
    }
  ];

  constructor(
    private sec: ExcSecurityService
  ) {
    this.currentUser = sec.UserName;
  }

  onSidemenueClick(component: string | null, settingType: number | undefined): void {
    if (component) {
      this._settingType = settingType;
      this.currentWidget = component;
    }
  }
}
